import React, { useState, useEffect } from "react";
import styles from './SettingsPage.module.css';
import { jwtDecode } from 'jwt-decode';
import { LuUser, LuUpload, LuMail, LuX, LuPlus, LuTriangleAlert } from 'react-icons/lu';
import PasswordInput from '../../components/PasswordInput/PasswordInput';
import {ConfirmationModal} from "../../components/ConfirmationModal/ConfirmationModal";
import api from '../../api/axios'; // Adjust the import based on your axios setup
import { useNavigate } from 'react-router-dom';

const SettingsPage = () => {

  const navigate = useNavigate(); // used to log user out *** IN FUTURE CALL ENDPOINT TO LOG USER OUT

  const [profilePicture, setProfilePicture] = useState(null);
  const [profileInfo, setProfileInfo] = useState({
    username: "",
    sport: "",
    display_name: "",
    school_name: "",
    mascot: "",
    division: ""
  });
  const [validSports] = useState(["Soccer", "Basketball"])
  const [newSecondaryEmail, setNewSecondaryEmail] = useState("");
  const [collegeDivisions] = useState(["Division I", "Division II", "Division III"])
  const [userData, setUserData] = useState({user_id: "", username:"", display_name:"", school_name:"", mascot:"", division:"", sport:""});
  const [error, setError] = useState("");
  const [update, setUpdate] = useState(true);
  const [secondaryEmails, setSecondaryEmails] = useState(["johndoe@gmail.com", "janedoe@outlook.com", "example@yahoo.com"])
  const [connectionsErrMsg, setConnectionsErrMsg] = useState('');
  const [profileEditMode, setProfileEditMode] = useState(false);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [validPwd, setValidPwd] = useState(false);
  const PWD_REGEX = /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
  const [matchPassword, setMatchPassword] = useState('');
  const [validMatch, setValidMatch] = useState(false);
  const [passwordErrMsg, setPasswordErrMsg] = useState('');

  const [isDeletePlayer, setIsDeletePlayer] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isDeleteEmail, setIsDeleteEmail] = useState(-1);

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(newPassword));
    setValidMatch(newPassword === matchPassword);
  }, [newPassword, matchPassword]);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
          console.error('No JWT token found.');
          return;
        }

        // decode jwt to get username 
        const decodedToken = jwtDecode(token);
        const user_id = decodedToken.user_id;
        const response = await api.get(`/userinfo/${user_id}`);
        setUserData(response.data);
        const email_data = await api.get(`/useremails/user/${user_id}`);
        /* returns something like
        [
          { user_email_id: 1, email_address: "john@example.com" },
          { user_email_id: 2, email_address: "jane@example.com" }
        ]*/
        console.log(email_data);
        setSecondaryEmails(email_data.data);
      } catch (err) {
        console.error("Error fetching user info:", err);
        setError("Failed to load user data.");
      }
    };
      fetchUserInfo();
  }, [update]);

  // When entering edit mode update profile info with user info for editable fields
  useEffect(() => {
    if (profileEditMode) {
      setProfileInfo({...userData});
    }
  }, [profileEditMode]);

/*
TODO
link display name to profile info after DB migration
create routing for checking password, confirming password, and changing password
add secondary email resets the page because it submits the form.
logout after delete account
*/

  const handleDeleteUser = async () => {
    try {
      console.log("Deleting user...");
      const user_id = userData.user_id
      console.log("Got user ID");
      await api.delete(`/users/${user_id}`);
      console.log("User deleted successfully");
    } catch (err) {
      console.error('Error deleting user:', err.response?.data || err.message);
      // You can set an error state here if needed
    }
  };

  const getUserIdFromToken = () => {
    try {
      const token = localStorage.getItem('jwtToken');
      if (!token) {
        console.error('No JWT token found.');
        return;
      }
      // decode jwt to get username 
      const decodedToken = jwtDecode(token);
      const user_id = decodedToken.user_id;
      return user_id;
    } catch (err) {
      console.error('error decoding token', err.response?.data || err.message);
      // You can set an error state here if needed
    }
  };

  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfilePicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };


  const handlePasswordSubmit = async () => {

    // If current password is correct, proceed to change password
    if (!validPwd || !validMatch) {
      setPasswordErrMsg('Invalid entry');
      return;
    }

    try {
    const response = await api.post('/change-password', 
    { 
      user_id: userData.user_id,
      current_password: currentPassword,
      new_password: newPassword
    });
    console.log("Password change response:", response.data);
    setPasswordErrMsg(response.data.msg);
    setCurrentPassword('');
    setNewPassword('');
    setMatchPassword('');
        
    } catch (err) {
      console.error('Login error:', err);
      // safe checks using optional chaining
      if (!err?.response) {
        setPasswordErrMsg('No server response. Please try again later.');
      } else if (err.response.status === 400) {
        setPasswordErrMsg('Missing password. Please try again.');
      } else if (err.response.status === 401) {
        setPasswordErrMsg('Incorrect password.');
      } else {
        setPasswordErrMsg('Login failed. Please try again.');
      }
    }
  };

  const handleProfileInputChange = (e) => {
    const { id, value } = e.target;
    setProfileInfo((prevInfo) => ({
      ...prevInfo,
      [id]: value,
    }));
  };

  const handleConnectionsInputChange = (e) => {
    setNewSecondaryEmail(e.target.value);
    setConnectionsErrMsg("") // Reset errors on change
  };

  const handleAddSecondaryEmail = async () => {
    try {
      const payload = {
        user_id: userData.user_id,
        email: newSecondaryEmail
      };
      const response = await api.post('/useremails/addemail', payload);
      console.log(response.data.message);
    }
    catch (err) {
      console.error('Error adding secondary email:', err.response?.data || err.message);
      setConnectionsErrMsg(err.response?.data.error || err.message)
      // You can set an error state here if needed
    }
  };

  const handleDeleteSecondaryEmail = async (user_email_id) => {
    try {
      await api.delete(`/useremails/${user_email_id}`);
      console.log("Secondary email deleted successfully");
    }
    catch (err) {
      console.error('Error adding secondary email:', err.response?.data || err.message);
      // You can set an error state here if needed
    }
  };

  // TODO: Create saves for all sections
  const handleProfileSave = async () => {
    try {
      // Example payload: update these with your actual state/props/values
      const payload = {
        user_id: userData.user_id,         // Must be a number
        username: profileInfo.username || null,    // New username (from input or state)
        sport: profileInfo.sport || null,
        display_name: profileInfo.display_name || null,
        school_name: profileInfo.school_name || null,
        mascot: profileInfo.mascot || null,
        division: profileInfo.division || null
      };

      const response = await api.post('/userinfo/update', payload);
      setUpdate(!update)
      if (response.status === 200) {
        localStorage.setItem('jwtToken', response.data.accessToken); // Update the token in local storage
        setProfileEditMode(false)
        // You can show a success toast or message here
      }
    } catch (err) {
      console.error('Error updating user info:', err.response?.data || err.message);
      // You can set an error state here if needed
    }
  };



  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageHeader}>
        <h1>Settings</h1>
        <p>Manage your account settings and preferences</p>
      </div>
      

      {/* Profile Container */}
      <main className={styles.profileContainer}>
        <header className={styles.profileHeader}>
          <div>
            <label className={styles.profileLabel}>Profile</label>
          </div>
          <div>
            <label className={styles.profileSubLabel}>Update your profile information and avatar</label>
          </div>
        </header>
        <header className={styles.profileHeader}>
          <div className={styles.profileSection}>
            {profilePicture ? (
              <img
                src={profilePicture}
                alt="Profile"
                className={styles.profilePicture}
              />
            ) : (
              <div className={styles.profilePicturePlaceholder}>
                < LuUser style={{fontSize: "50px"}}/>

                {profileEditMode && (
                  <>
                    <button 
                      className={styles.uploadButton} 
                      onClick={() => document.getElementById("fileInput").click()}
                    >
                      <LuUpload style={{fontSize: "20px"}}/>
                    </button>

                    <input
                      id="fileInput"
                      type="file"
                      accept="image/*"
                      onChange={handleProfilePictureChange}
                      style= {{display:"none"}}
                    />
                  </>
                )}
              </div>
            )}
            </div>
        </header>
        <hr style={{ borderTop: "1px solid lightgrey", width: "100%" }} />
        <form className={styles.formContainer}>
        {profileEditMode ? (
        <div className={styles.userInfoContainer}>
            <div>
            <label htmlFor="username" className={styles.inputLabel}><strong>Username</strong></label>
              <input
                type="text"
                id="username"
                className={styles.inputField}
                value={profileInfo.username}
                onChange={handleProfileInputChange}
              />
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Sport</strong></label>
              <select
                id="sport"
                className={styles.inputField}
                name={"sport"} 
                placeHolder={userData.sport}
                value={profileInfo.sport} 
                onChange={handleProfileInputChange}
              >
                {validSports.map((sport, index) => (
                  <option key={index} value={sport}>
                    {sport}
                  </option>
                ))}
              </select>
              </div>
            <div>
              <label className={styles.inputLabel}><strong>Display Name</strong></label>
              <input
                type="display_name"
                id="display_name"
                className={styles.inputField}
                placeholder={userData.display_name}
                value={profileInfo.display_name}
                onChange={handleProfileInputChange}
              />
            </div>
            <div>
              <label className={styles.inputLabel}><strong>College / University Name</strong></label>
              <input
                type="school_name"
                id="school_name"
                className={styles.inputField}
                placeholder={userData.school_name}
                value={profileInfo.school_name}
                onChange={handleProfileInputChange}
              />
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Mascot / Team Name</strong></label>
              <input
                type="mascot"
                id="mascot"
                className={styles.inputField}
                placeholder={userData.mascot}
                value={profileInfo.mascot}
                onChange={handleProfileInputChange}
              />
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Sport Division</strong></label>
              <select
                id="division"
                className={styles.inputField}
                name={"division"}
                placeHolder={userData.division}
                value={profileInfo.division} 
                onChange={handleProfileInputChange}
              >
                {collegeDivisions.map((d, index) => (
                  <option key={index} value={d}>
                    {d}
                  </option>
                ))}
              </select>
              </div>
          </div>
        ) : (
          <div className={styles.userInfoContainer}>
            <div>
              <label className={styles.inputLabel}><strong>Username</strong></label>
              <label className={styles.inputField}>{userData.username}</label>
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Sport</strong></label>
              <label className={styles.inputField}>{userData.sport}</label>
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Display Name</strong></label>
              <label className={styles.inputField}>{userData.display_name}</label>
            </div>
            <div>
              <label className={styles.inputLabel}><strong>College / University Name</strong></label>
              <label className={styles.inputField}>{userData.school_name}</label>
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Mascot / Team Name</strong></label>
              <label className={styles.inputField}>{userData.mascot}</label>
            </div>
            <div>
              <label className={styles.inputLabel}><strong>Sport Division</strong></label>
              <label className={styles.inputField}>{userData.division}</label>
            </div>
          </div>
        )}
        </form>
        {profileEditMode ? (
          <div className = {styles.buttonContainer}>
            <button className={styles.buttonB} onClick={() => setProfileEditMode(false)}>Cancel</button>
            <button className={styles.buttonA} onClick={handleProfileSave}>Save</button>
          </div>
        ) : (
          <div className = {styles.buttonContainer}>
            <button className={styles.buttonA} onClick={() => setProfileEditMode(true)}>Edit</button>
          </div>
        )}
      </main>

      {/* Connections Container */}
      <main className={styles.profileContainer}>
        <header className={styles.profileHeader}>
          <div>
            <label className={styles.profileLabel}>Connections</label>
          </div>
          <div>
            <label className={styles.profileSubLabel}>Add additional emails to account</label>
          </div>
        </header>

        <div>
          {secondaryEmails.map((value) => (
            <div key={value.user_email_id} className={styles.connectionsForm}>
              <div className={styles.inputField}>
                {<LuMail className={styles.userInfoIcon}/>}
                <p style={{overflow:"hidden"}}>{value.email_address}</p>
                <button className={styles.deleteButton} onClick={() => setIsDeleteEmail(value.user_email_id)}>
                  {<LuX/>}
                </button>
              </div>
            </div>
          ))}

          <div>
            <hr style={{ borderTop: "1px solid lightgrey", width: "100%" }} />
            <header className={styles.profileHeader}>
              <label className={styles.inputLabel} style={{marginTop: "10px"}}><strong>Add Secondary Email</strong></label>
            </header>

            <div className={styles.connectionsForm}>
              <div className={`${styles.inputField} ${connectionsErrMsg ? styles.inputError : ''}`}>
                <input
                  type="email"
                  id="new_email"
                  className={styles.input}
                  autoComplete = "off"
                  placeholder={"new@gmail.com"}
                  value={newSecondaryEmail}
                  onChange={handleConnectionsInputChange}
                />
                <button className={styles.addButton} onClick={() => handleAddSecondaryEmail()}>
                  <LuPlus/>
                </button>
              </div>
            </div>
            <label className={styles.errorMsg}>{connectionsErrMsg}</label>
          </div>

          {isDeleteEmail !== -1 && (
          <ConfirmationModal
            message="Are you sure you want to delete your account? This action cannot be undone or aborted."
            onConfirm={() => {(handleDeleteSecondaryEmail(isDeleteEmail)); setIsDeleteEmail(-1)}}
            onCancel={() => setIsDeleteEmail(-1)}
          />
          )}
        </div>
      </main>

      {/* Password Container */}
      <main className={styles.profileContainer}>
        <header className={styles.profileHeader}>
          <div>
            <label className={styles.profileLabel}>Password</label>
          </div>
          <div>
            <label className={styles.profileSubLabel}>Change your account password</label>
          </div>
        </header>

        <div className={styles.formContainer}>
          {/*Current Password*/}
          <div className={`${styles.inputGroup} ${styles.passwordInput}`}>
            <label htmlFor="password" className={styles.inputLabel}><strong>Current Password</strong></label>
            <PasswordInput
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete = "current-password"
              placeHolder = "Enter your current password"
              required
            />
          </div>
          {/*New Password*/}
          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.inputLabel}><strong>New Password</strong></label>
            <PasswordInput
              id = "new_password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete = "new-password"
              error={newPassword && !validPwd}
              instructions = "Password must be 8-24 characters, include letters, numbers, and special characters"
              placeHolder = "Enter your new password"
              required 
            />
          </div>
            {/*Confirm Password*/}
            <div className={styles.inputGroup}>
                <label htmlFor="confirm_pwd" className={styles.inputLabel}><strong>Confirm New Password</strong></label>
                <PasswordInput
                    id = "confirm_password"
                    value={matchPassword}
                    onChange={(e) => setMatchPassword(e.target.value)}
                    autoComplete = "new-password"
                    error={matchPassword && !validMatch}
                    instructions = "Must match new password"
                    placeHolder = "Enter your new password again"
                    required 
                />
            </div>
            <label className={styles.inputLabel}></label>
            <button className={styles.changePasswordButton} onClick={() => {setIsChangePassword(true)}}><strong>Change Password</strong></button>
            <label style={{justifyContent: "center", textAlign: "center"}}>{passwordErrMsg}</label>
            {isChangePassword && (
            <ConfirmationModal
              message="Are you sure you want to change your password?"
              onConfirm={() => {handlePasswordSubmit(); setIsChangePassword(false) }}
              onCancel={() => setIsChangePassword(false)}
            />
          )}
        </div>
      </main>

      {/* Danger Zone Container */}
      <main className ={styles.dangerZoneContainer}>
        <header className={styles.profileHeader}>
          <div className={styles.dangerZoneHeader}>
            <LuTriangleAlert/>
            <label>Danger Zone</label>
          </div>
          <div>
            <label className={styles.profileSubLabel}>Irreversible actions that affect your account</label>
          </div>
        </header>

        <div className={styles.dangerZoneForm} >
          <div>
            <div>
              <label className={styles.profileSubLabel}><strong>Delete Account</strong></label>
            </div>
            <div>
              <label className={styles.profileSubLabel}>Permanently delete your account and all data</label>
            </div>
          </div>
          <button className={styles.deleteAccountButton} onClick={() => {setIsDeletePlayer(true)}}>Delete Account</button>
          {isDeletePlayer && (
            <ConfirmationModal
              message="Are you sure you want to delete your account? This action cannot be undone or aborted."
              onConfirm={() => {
                handleDeleteUser();
                localStorage.clear(); // Clears all browser storage (including jwtToken) to ensure complete logout 
                navigate('/');
              }}
              onCancel={() => setIsDeletePlayer(false)}
            />
          )}
        </div>
      </main>
    </div>
  );
};

export default SettingsPage;
 